import { Link } from 'react-router-dom';
import { heroSlides, stats } from '@/mocks/home';

export default function HeroSection() {
  const slide = heroSlides[0];

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20geometric%20minimal%20background%20with%20soft%20flowing%20lines%2C%20elegant%20modern%20design%2C%20clean%20composition%2C%20luxurious%20feeling%2C%20cream%20and%20warm%20sand%20tones%2C%20subtle%20texture%2C%20high%20end%20aesthetic&width=1600&height=900&seq=hero-bg-91wang&orientation=landscape"
          alt="91网平台背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          {slide.title}
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          {slide.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to={slide.ctaLink}
            className="px-8 py-3.5 bg-primary-500 text-white font-medium rounded-md hover:bg-primary-600 transition-colors text-base whitespace-nowrap cursor-pointer"
          >
            {slide.cta}
          </Link>
          <Link
            to={slide.secondaryCtaLink}
            className="px-8 py-3.5 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-colors text-base whitespace-nowrap cursor-pointer"
          >
            {slide.secondaryCta}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-14">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-white">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}